import {
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal
} from '@chakra-ui/react';
import { AiOutlineFilter } from 'react-icons/ai';
import React, { useEffect, useState } from 'react';
import {
  useMonitorTableMenuFiltersMutation,
  useMonitorTableMenuFiltersQuery
} from '../../query/monitorTableMenuFilterQueries';
import {
  useMonitorTableMenuColumnsMutation,
  useMonitorTableMenuColumnsQuery
} from '../../query/monitorTableMenuColumnQueries';
import {
  MonitorTransport,
} from '@um/uptime-monitoring-shared';

const MonitorTableMenu = () => {
  const { data: filtersData } = useMonitorTableMenuFiltersQuery('');
  const { data: columnsData } = useMonitorTableMenuColumnsQuery('');
  const { mutate: filtersMutate } = useMonitorTableMenuFiltersMutation('');
  const { mutate: columnsMutate } = useMonitorTableMenuColumnsMutation('');
  const [ monitorTypeChecks, setMonitorTypeChecks ] = useState([]);

  useEffect(() => {
    addMonitorChecks();
  }, [filtersData]);

  const addMonitorChecks = () => {
    let monitorChecksList = [];
    const keys = Object.values(MonitorTransport)

    keys.forEach((transport) => {
      if((Object(filtersData).hasOwnProperty(transport) && filtersData[transport]) || !Object(filtersData).hasOwnProperty(transport)){
        monitorChecksList.push(transport);
      }
    })
    setMonitorTypeChecks([...monitorChecksList]);
  }
  
  const onOptionClick = (transport) => {
    filtersMutate(
      { filters: 
        { ...(filtersData || {}), 
          [transport]: Object(filtersData).hasOwnProperty(transport) ? !filtersData[transport] : true 
        } 
      }
      )
  }
  
  return (<Menu closeOnSelect={false}>
    <MenuButton
      as={IconButton}
      variant="ghost"
      icon={<Icon as={AiOutlineFilter} boxSize={6} color="gray.400"/>}
    >
      Open menu
    </MenuButton>
    <Portal>
      <MenuList>
        <MenuOptionGroup title="Monitor Type" type="checkbox" value={monitorTypeChecks}>
          {
            Object.values(MonitorTransport).map((transport) => 
              <MenuItemOption 
                value={transport} 
                onClick={() => onOptionClick(transport)}>
                {transport.replaceAll("_", " ")}
              </MenuItemOption>
            )
          }
        </MenuOptionGroup>
        <MenuOptionGroup title="Columns" type="checkbox" value={[ !!columnsData?.responseTime && "responseTime", !!columnsData?.uptime && "uptime", !!columnsData?.sslExpiry && 'sslExpiry']}>
          <MenuItemOption value="responseTime" onClick={() => columnsMutate({ columns: { ...(columnsData || {}), responseTime: !columnsData?.responseTime } })}>Response Time</MenuItemOption>
           <MenuItemOption value="uptime" onClick={() => columnsMutate({ columns: { ...(columnsData || {}), uptime: !columnsData?.uptime } })}>Uptime</MenuItemOption>
          <MenuItemOption value="sslExpiry" onClick={() => columnsMutate({ columns: { ...(columnsData || {}), sslExpiry: !columnsData?.sslExpiry } })}>SSL expiry</MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Portal>
  </Menu>);
};

export default MonitorTableMenu;